import { getFeatureProfile, type FeatureProfile } from '@agentwiki/shared'

type WebFeatureEnv = Partial<Record<
  'FEATURE_EXTRACTION' | 'FEATURE_STORAGE_SPACE' | 'FEATURE_SECRETS_ADVANCED',
  unknown
>>

export function getWebFeatureProfile(env: WebFeatureEnv = import.meta.env): FeatureProfile {
  return getFeatureProfile(env)
}
